import React from 'react';
import V1CTAButton from './V1CTAButton';
import './V1CaseStudy.css';

interface V1CaseStudyProps {
  theme: 'premium' | 'energetic';
  onCTAClick: () => void;
}

const V1CaseStudy: React.FC<V1CaseStudyProps> = ({ theme, onCTAClick }) => {
  return (
    <section className="v1-case-study v1-section">
      <div className="v1-container">
        <h2 className="v1-section-title v1-animate-in">
          {theme === 'premium' ? 'Historia Sukcesu: Anna' : '⭐ HISTORIA SUKCESU: ANNA'}
        </h2>

        <div className="v1-case-study-content">
          <div className="v1-case-study-metrics v1-glass v1-animate-in">
            <div className="v1-metric">
              <div className="v1-metric-label">Przed</div>
              <div className="v1-metric-value">56%</div>
            </div>
            <div className="v1-metric-arrow">→</div>
            <div className="v1-metric">
              <div className="v1-metric-label">Po</div>
              <div className="v1-metric-value v1-accent-text">91%</div>
            </div>
          </div>

          <div className="v1-case-study-story v1-animate-in" style={{ animationDelay: '0.2s' }}>
            <p>Anna przyszła do nas 8 tygodni przed maturą rozszerzoną, zestresowana i niepewna swoich umiejętności. Dzięki naszemu strukturalnemu podejściu i technikom redukcji stresu, nie tylko zdała egzamin - przekroczyła swoje najśmielsze oczekiwania o 35 punktów!</p>
          </div>

          <div className="v1-case-study-cta v1-animate-in" style={{ animationDelay: '0.4s' }}>
            <V1CTAButton variant="primary" size="large" urgency={true} theme={theme} onClick={onCTAClick}>
              Zacznij bez stresu
            </V1CTAButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default V1CaseStudy;
